import { useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus, Trash2 } from 'lucide-react';

export function ActionItemsSection({ items, trainers, editable, onChange }) {
  const update = (i, field, value) => {
    const next = [...items];
    next[i] = { ...next[i], [field]: value };
    onChange(next);
  };
  const add = () => onChange([...items, { description: '', due_date: '', trainer_user_id: '' }]);
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));

  if (!editable) {
    return (
      <div className="space-y-1" data-testid="action-items-readonly">
        {items.length === 0 && <p className="text-sm text-muted-foreground">No action items.</p>}
        {items.map((it, i) => (
          <div key={it.id || i} className="text-sm border rounded-md p-2">
            <span className="font-medium">{it.description}</span>
            {it.due_date && <span className="text-muted-foreground"> — due {it.due_date}</span>}
            {it.trainer_name && <span className="text-muted-foreground"> — trainer: {it.trainer_name}</span>}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-2" data-testid="action-items-editable">
      {items.map((item, i) => (
        <div key={i} className="flex gap-2 items-start border rounded-md p-2" data-testid={`action-item-row-${i}`}>
          <Input placeholder="Description" value={item.description || ''}
            onChange={(e) => update(i, 'description', e.target.value)} className="flex-1" />
          <Input type="date" value={item.due_date || ''} onChange={(e) => update(i, 'due_date', e.target.value)} className="w-36" />
          <Select value={item.trainer_user_id || ''} onValueChange={(v) => update(i, 'trainer_user_id', v)}>
            <SelectTrigger className="w-40"><SelectValue placeholder="Trainer" /></SelectTrigger>
            <SelectContent>
              {(trainers || []).map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button type="button" size="icon" variant="ghost" onClick={() => remove(i)} data-testid={`action-item-remove-${i}`}>
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" onClick={add} data-testid="action-item-add-btn">
        <Plus className="h-3 w-3 mr-1" /> Add action item
      </Button>
    </div>
  );
}
